import React from 'react';

import classes from './TabsBlock.module.css';
import OutcomeLabelTabs from 'components/outcome-label/outcome-label-tabs/OutcomeLabelTabs';
import BetOfferLabelTabs from 'components/betOffer-label/betOffer-label-tabs/BetOfferLabelTabs';
import { UtilsTypes } from 'constants/utilsTypes';
import GetPotentialPayoutTabs from 'pages/potentialPayout/getPotentialPayout/get-potential-payout-tabs/GetPotentialPayoutTabs';
import GetSystemCombinationsTabs from 'components/system-combinations/tabs/GetSystemCombinationsTabs';

const TabsBlock = ({ title, type }) => {
    return (
        <div className={classes.TabsBlock}>
            <p className={classes.Title}>{title}</p>
            {type === UtilsTypes.OUTCOME_LABEL && <OutcomeLabelTabs />}
            {type === UtilsTypes.BETOFFER_LABEL && <BetOfferLabelTabs />}
            {type === UtilsTypes.POTENTIAL_PAYOUT && <GetPotentialPayoutTabs />}
            {type === UtilsTypes.SYSTEM_COMBINATIONS && (
                <GetSystemCombinationsTabs />
            )}
        </div>
    );
};

export default TabsBlock;
